module.exports = __webpack_public_path__ + "static/media/step3-nutritionists.9a4e0294.png";